import React, {Fragment} from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import _ from 'lodash'

const tableStyle = {
  backgroundColor: '#ffffff',
}

const headerStyle = {
  color: 'black',
}

const divStyle = {
  paddingTop: '30px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'black',
  paddingRight: '10px',
  border: 'none',
}

const aStyle = {
  display: 'none',
}

class Table extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      nameSorting: 'ASC',
      managersSorting: 'DESC',
      oncallSorting: 'DESC',
      columnSorting: 'name',
    }
  }

  renderHeader() {
    return <Fragment><th key="name"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('name')}>Name</a></th><th key="managers"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('managers')}>Managers</a></th><th key="oncall"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('oncall')}>Is this an OnCall Team?</a></th><th key="actions" colSpan="3">Actions</th></Fragment>
  }

  renderDataWith(myData) {
    return Object.keys(myData).map((key) => {
      const team = myData[key]
      const le = '/edit_team/' + team['id']
      const l = '/teams/' + team['id'] + '/members'
      if (team.is_admin) {
        return <tr key={key}><td>{team['name']}</td><td>{team['managers']}</td><td>{team['oncall']}</td><td colSpan="3"><a href={l} style={linkStyle}>Manage members</a><a href={le} style={linkStyle}>Update</a><a href="#" onClick={() => this.handleSubmit(team['id'])} style={linkStyle}>Delete</a></td></tr>
      } else if (team.is_manager) {
        return <tr key={key}><td>{team['name']}</td><td>{team['managers']}</td><td>{team['oncall']}</td><td colSpan="3"><a href={l} style={linkStyle}>Manage members</a></td></tr>
      } else {
        return <tr key={key}><td>{team['name']}</td><td>{team['managers']}</td><td>{team['oncall']}</td><td colSpan="3"></td></tr>
      }
    }
    )
  }

  renderData() {
    let myData = null
    if (!this.props.headers.includes(this.state.columnSorting)) {
      this.setState({columnSorting: 'name', nameSorting: 'ASC'})
    }

    const header = this.state.columnSorting
    const headerSorting = header + 'Sorting'
    if (this.state[headerSorting] === 'ASC') {
      myData = _.orderBy(Object.values(this.props.teams), [ header ], [ 'asc' ])
    } else {
      myData = _.orderBy(Object.values(this.props.teams), [ header ], [ 'desc' ])
    }
    
    return this.renderDataWith(myData)
  }

  render() {
    return <div className="row justify-content-center align-items-center" style={divStyle}><a href="/employee/teams" id="mylink" style={aStyle}></a><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeader()}</tr>{this.renderData()}</tbody></table></div>
  }

  handleHeaderClick(header) {
    if (!this.props.headers.includes(header)) {
      return
    }

    const headerSorting = header + 'Sorting'
    const currentState = Object.assign({}, this.state)
    currentState.columnSorting = header
    if (currentState[headerSorting] === 'ASC') {
      currentState[headerSorting] = 'DESC'
    } else {
      currentState[headerSorting] = 'ASC'
    }
    this.setState(currentState)
  }

  handleSubmit(idT) {
    let urlf = '/api/v1/teams/'
    urlf = urlf + idT.toString()
    confirmAlert({
      title: 'Confirm',
      message: 'Are you sure to delete this team?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            fetch(urlf, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(response => response.json())
            .then(() => {
              document.getElementById('mylink').click()
            })
            .catch((err) => {
              console.error('Error while deleting team! ' + err)
            })
          },
        },
        {
          label: 'No',
          onClick: () => {
            document.getElementById('react-confirm-alert').close
          },
        },
      ],
    })
  }
}

Table.propTypes = {
  teams: PropTypes.object,
  headers: PropTypes.array,
}


export default Table
